import React, { Fragment, useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import PrintIcon from "@material-ui/icons/Print";
import { printRecipt } from "./PrintReceiptsUtil";
import Modal from "@material-ui/core/Modal";
import CloseIcon from "@material-ui/icons/Close";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import ChangeCreationDateReceipt from "./changeCreationReceipt/ChangeCreationDateReceipt";
import ModalRefunds from "./ModalRefunds";
import AlertModal from '../../../../shared/components/Modal';

const no_op = () => {};
const ReceiptsAdmisionsListActions = ({
  data,
  admision,
  refreshList = no_op,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalChangeCreationDate, setOpenModalChangeCreationDate] =
    useState(false);
  const [openModalRefund, setOpenModalRefund] = useState(false);
  const [showAlertModal, setShowAlertModal] = React.useState(false);
  const [colorAlertModal, setAlertColorModal] = React.useState("");
  const [messagAlerteModal, setAlertMessageModal] = React.useState(null);

  const printReceiptData = () => {
    setOpenModal(true);
    printRecipt(data.data.original, admision);
  };

  const onToggleToChangeCreationDate = () => {
    setOpenModalChangeCreationDate(true);
  };

  const refunds = () => {
    if (
      data.data.original.recibo_cancelado === false 
    ) {
      setOpenModalRefund(true);
    }
    if (data.data.original.recibo_cancelado) {
      setShowAlertModal(true);
      setAlertColorModal("warning");
      setAlertMessageModal("No se puede hacer la devolución el estado del recibo esta anulado");
    }
    
  };

  return (
    <Fragment>
      <td role="cell">
        <Tooltip title="Imprimir Recibo de Caja">
          <IconButton
            aria-label="unable"
            style={{ padding: 2 }}
            onClick={() => {
              printReceiptData();
            }}
          >
            <PrintIcon />
          </IconButton>
        </Tooltip>
        <Tooltip
          title="Cambiar Fecha de Creación del Recibo de Caja"
          style={{ margin: "0.25em 0.75em", width: "0.7em", height: "0.5em" }}
        >
          <IconButton
            aria-label="unable"
            onClick={() => {
              onToggleToChangeCreationDate(admision);
            }}
          >
            <FontAwesomeIcon
              icon={faPenToSquare}
              style={{ width: "0.75em", height: "0.75em" }}
            />
          </IconButton>
        </Tooltip>
        <Tooltip
          title="Devoluciones"
          style={{ margin: "0.25em 0.75em", width: "0.3em", height: "0.5em" }}
        >
          <IconButton
            aria-label="unable"
            onClick={() => {
              refunds();
            }}
          >
            <FontAwesomeIcon
              icon={faHandHoldingDollar}
              style={{ width: "0.75em", height: "0.75em" }}
            />
          </IconButton>
        </Tooltip>
      </td>

      <Modal
        open={openModalChangeCreationDate}
        onClose={() => {
          setOpenModalChangeCreationDate(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: 1000, margin: 10 }}
        >
          <div className="card__title">
            <h4 className="bold-text">Cambiar Fecha de Creación del Recibo</h4>
          </div>
          <div>
            <ChangeCreationDateReceipt
              receipt={data.data.original}
              admision={admision}
              setOpenModalChangeCreationDate={setOpenModalChangeCreationDate}
              refreshList={refreshList}
            />
          </div>
        </div>
      </Modal>
      <Modal
        open={openModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "120%", margin: 10 }}
        >
          <IconButton
            style={{ float: "right" }}
            onClick={() => {
              setOpenModal(false);
            }}
          >
            <CloseIcon />
          </IconButton>
          <iframe id="pdfV" width="1000" height="600"></iframe>
        </div>
      </Modal>
      <Modal
        open={openModalRefund}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 600 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "60%", margin: 10 }}
        >
          <ModalRefunds
            admision={admision}
            closeModal={() => setOpenModalRefund(false)}
            receipt={data.data.original}
          />
        </div>
      </Modal>
      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => {
          switch (colorAlertModal) {
            case "warning":
              setShowAlertModal(false);
              break;
          }
        }}
        toggle={() => {
          setShowAlertModal(false);
          switch (colorAlertModal) {
            case "warning":
              setAlertColorModal("warning");
              setAlertMessageModal("");
              break;
          }
        }}
      />
    </Fragment>
  );
};

export default ReceiptsAdmisionsListActions;
